import {
  useGetContext,
  useGetSharedFunctionality,
} from '../../api/lending/lapiHooks';

export function useSoleTraderPilot() {
  const { context } = useGetContext();
  const { functionality } = useGetSharedFunctionality();

  return {
    eligible: context.isOnSoleTraderPilot,
    acceptingNewApprovals: functionality?.new_st_approvals_enabled || false,
  };
}
